import React from 'react';
import ContentBaseLayout from '../shared/ContentBaseLayout';
import NoElementsFound from '../../../shared/components/NoElementsFound';
import { useParams } from 'react-router';
import { useLocalRegions } from '../../../api/local-content/marketplace/local-regions/useLocalRegions';
import { LoadingWrapper } from '../../../shared/components/LoadingWrapper';
import LoadingOverlay from '../../../shared/components/LoadingOverlay';
import { useAgeCategorySearchParam } from '../../../shared/utils/useAgeCategorySearchParam';
import { Navigate } from 'react-router-dom';

export const LocalRegionsRedirect = () => {
    const { shopLanguage } = useParams<'shopLanguage'>();

    const { value: ageCategory, searchParam: ageCategorySearchParam } = useAgeCategorySearchParam();
    const searchParams = new URLSearchParams(ageCategorySearchParam ? { ageCategory: ageCategorySearchParam } : {});

    const { localRegions, isLoading: isLocalRegionsLoading } = useLocalRegions(ageCategory, shopLanguage);

    if (isLocalRegionsLoading) {
        return (
            <LoadingWrapper>
                <LoadingOverlay loading={true} />
            </LoadingWrapper>
        );
    }

    if (localRegions.length > 0) {
        return <Navigate to={{ pathname: `${localRegions[0].name}`, search: searchParams.toString() }} replace />;
    }

    return (
        <ContentBaseLayout documentTitle="Local Regions" contentComponent={<NoElementsFound type="localRegions" />} />
    );
};
